import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { passConfig } from 'kts-platform-frame/utils';
import { history } from 'kts-platform-frame/routes';
import {
    Form,
    Input,
    Icon,
    Button
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 7
            },
            wrapperCol: {
                span: 16
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                span: 16,
                offset: 7
            },
        };
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const passConfigArr = this.modulesState.passConfigArr;
        return (
            <div className={css['modify']}>
                <header>
                    <span className={css['modify-log']}></span>
                    <h2> | 修改密码</h2>
                </header>
                <div className={css['modify-content']}>
                    <Form
                        onSubmit={this.modifyPsd}
                    >
                        <FormItem
                            label="电子邮箱"
                            colon={false}
                            {...formItemLayout}
                        >
                            {
                                getFieldDecorator('email', {
                                })
                                (
                                    (
                                        <span>{this.modulesState.email}</span>
                                    )
                                )
                            }
                        </FormItem>
                        <FormItem
                            label="旧密码"
                            colon={false}
                            {...formItemLayout}
                        >
                            {
                                getFieldDecorator('oldPass', {
                                    rules: [
                                        {
                                            required: true, message: '请输入旧密码'
                                        }
                                    ]
                                })
                                (
                                    <Input
                                        type="password"
                                        placeholder="请输入密码"
                                        className={css['modify-content-input']}
                                    />
                                )
                            }
                        </FormItem>
                        <div className={css['modify-content-new']}>
                            <FormItem
                                label="新密码"
                                colon={false}
                                {...formItemLayout}
                            >
                                {
                                    getFieldDecorator('newPass', {
                                        rules: [
                                            {
                                                required: true, message: '请输入密码'
                                            },
                                            {
                                                validator: this.newPsdCheck
                                            }
                                        ]
                                    })
                                    (
                                        <Input
                                            placeholder="请输入密码"
                                            className={css['modify-content-input']}
                                            type="password"
                                            onChange={this.newPasswordCheck}
                                            onFocus={this.newPasswordFocus}
                                            onBlur={this.newPasswordBlur}
                                        />
                                    )
                                }
                            </FormItem>
                            {
                                (this.modulesState.newPasTipView && !this.modulesState.passConcigArrView) && <p className={css['mcn-tip']}>{this.modulesState.newPasTipMessage}</p>
                            }
                            {
                                this.modulesState.passConcigArrView &&
                                <div className={css['mcn-judge']}>
                                    {
                                        passConfigArr && passConfigArr.map(el => {
                                            return (
                                                <span 
                                                    key={el['message']}
                                                    className={css['mcn-judge-info']}
                                                >
                                                    {el['message']}
                                                    {
                                                        el['statu'] ? <Icon type="zhengque"/> : <Icon type="cuowu"/>
                                                    }
                                                </span>  
                                            );
                                        })
                                    }
                                </div>
                            }
                        </div>
                        <FormItem
                            label="确认新密码"
                            colon={false}
                            {...formItemLayout}
                        >
                            {
                                getFieldDecorator('newPass1', {
                                    rules: [
                                        {
                                            required: true, message: '请确认密码'
                                        },
                                        {
                                            validator: this.compareToFirstPassword,
                                        }
                                    ]
                                })
                                (
                                    <Input
                                        placeholder="请输入密码"
                                        className={css['modify-content-input']}
                                        onBlur={this.handleConfirmBlur}
                                        type="password"
                                    />
                                )
                            }
                        </FormItem>
                        <FormItem
                            {...tailFormItemLayout}
                        >
                            <div className={css['modify-content-handler']}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    修改密码
                                </Button>
                                <Button
                                    className={css['modify-content-handler-abandon']}
                                    onClick={this.abandon}
                                >
                                    放弃
                                </Button>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <footer className={css['modify-footer']}>
                    <div className={css['modify-footer-operate']}>
                        <Icon type="dianhua" style={{ color: '#BCC7D3', fontSize: '18px', marginRight: '10px'}} /><span>服务热线 ：400-836-3566 &nbsp;|</span>
                        <Icon type="xiaoxi1" style={{ color: '#BCC7D3', fontSize: '18px', marginLeft: '10px', marginRight: '10px'}} /><span><a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a></span>
                    </div>
                    <div className={css['modify-footer-adress']}>迅联集团 2018 粤ICP备17007740号-1</div>
                </footer>
            </div>
        );
    }

    private judgeSubmit = (opt) => {
        return opt['statu'] === true;    
    }

    private modifyPsd = (e) => {
        e.preventDefault();
        let passConfigArr = this.modulesState.passConfigArr;
        let passConfigArrStatu = passConfigArr.every(this.judgeSubmit);
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && passConfigArrStatu) {
                values['email'] = this.modulesState.email;
                ModulesAction.updatePassword(values);
            }
        });
    }

    private newPasswordFocus = () => {
        ModulesAction.changeNewPasTipView(true);
    }

    private newPasswordBlur = () => {
        ModulesAction.changeNewPasTipView(false);
        ModulesAction.changePassConfigArrView(true);
        let newPass = this.props.form.getFieldsValue(['newPass']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPass['newPass']);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private abandon = () => {
        history.push(`/`);
    }

    private compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPass')) {
            callback('两次密码不一致');
        } else {
            callback();
        }
    }
    
    private newPasswordCheck = (e) => {
        const value = e.target.value;
        const passConfigArr = passConfig(this.modulesState.passConfig, e.target.value);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private newPsdCheck = (rule, value, callback) => {
        let newPassword = this.props.form.getFieldsValue(['newPass']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPassword['newPass']);
        if (newPassword && this.modulesState.confirmDirty) {
            this.props.form.validateFields(['newPass1'], {force: true}, () => {});
        }
        if (!passConfigArr.every(this.judgeSubmit)) {
            callback(' ');
        } else {
            callback();
        }
    }

    private handleConfirmBlur = () => {
        ModulesAction.updateConfirmDirty();
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/ModifyPas/UI.Components.tsx